<template>
  <div class="MultipleRiod">
    <el-dialog
      title="数量"
      width="922px"
      append-to-body
      :visible.sync="visible"
      @open="open"
      @close="clearData"
      :show="show"
      :close-on-click-modal="false"
    >
      <div style="height: 300px">
        <div class="MultipleRiod_box" id="key_content" ref="key_content">
          <h3>商品名称: {{ tableDatarow.FullName }}</h3>
          <div class="dw">
            当前单位: {{ tableDatarow.UnitName }}
            <span>合计: {{ Total }}</span>
          </div>
        </div>
        <div>
          <vxe-table
            border
            highlight-hover-row
            highlight-current-row
            :data="tableDatasl"
            ref="xTable"
            height="180px"
            :header-cell-style="{
              background: '#eef1f6',
              color: '#000',
              fontSize: '16px',
              height: '37px',
              padding: '0',
              fontWeight: 'bold',
            }"
            :footer-row-style="{
              background: '#eef1f6',
              color: '#000',
              fontSize: '14px',
              height: '30px',
              padding: '0',
            }"
            :footer-cell-style="{
              background: '#fff',
              color: '#000',
              fontSize: '14px',
              height: '30px',
              padding: '0',
            }"
          >
            <template v-for="(item, index) in ObtainHeader">
              <vxe-table-column
                :key="index"
                :field="item.Key"
                :title="item.Rename"
                align="center"
                v-if="item.Key == 'Qty'"
              >
                <template v-slot="{ row, rowIndex }">
                  <div class="input_box ub ub-ac">
                    <input
                      ref="Serialfocus"
                      :id="'x_' + rowIndex + '_y_' + index"
                      v-model.lazy="row[item.Key]"
                      class="input_stt"
                      @keyup.up="UpArrows(row, rowIndex, index)"
                      @keyup.enter="DwArrows(row, rowIndex, index)"
                      @keyup.down="DwArrows(row, rowIndex, index)"
                      @blur="changeData(row, index, item.Key, row[item.Key])"
                      @focus="doFocu"
                      @change="
                        row[item.Key] = row[item.Key].replace(
                          /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                          '$1'
                        )
                      "
                    />
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                v-else
                :key="index"
                :field="item.Key"
                :title="item.Rename"
                align="center"
              ></vxe-table-column>
            </template>
          </vxe-table>
          <div class="btnnimiserial">
            <el-button size="mini" type="primary" @click="clickDetermine"
              >确定</el-button
            >
            <el-button size="mini" @click="$emit('update:show', false)"
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>  

<script>
// 工具库
import tool from "@/utils/tool"; //本地缓存存取
import { locale } from "moment";

export default {
  data() {
    return {
      modeltrue: false,
      MultipleRiodSelection: [], // 多选数据
      serialnumber: "", // 序列号单选
      serialnumberrise: "", // 序列号多选 起
      serialnumberstop: "", // 序列号多选 止
      checked: false, // 是否批量录入
      Total: "", // 合计
      tableDatarow: {}, // 数量当前数据
      itemKey: "",
      ObtainHeader: [
        { Key: "UnitId", Rename: "序号" },
        { Key: "UnitName", Rename: "单位" },
        { Key: "Percent", Rename: "换算率" },
        { Key: "Qty", Rename: "数量" },
      ], // 多单位 表头
      visible: this.show,
      tableDatasl: [], // 多单位数据
      FullName: "", //当前商品名
      UnitName: "", // 当前单位
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show;
    },
    visible: {
      handler(val, l) {
        if (val) {
          this.tableDatasl = this.$attrs.tableData.UnitData; // 单位数据
          this.tableDatarow = this.$attrs.tableData;
          this.tableDatasl.map((item) => {
            if (item.Unit == this.$attrs.tableData.Unit) {
              item.Qty = this.$attrs.tableData.Qty;
              this.Total = Number(this.$attrs.tableData.Qty).toFixed(
                tool.getLocal("get_config").moneyPoint
              );
            }
            if (item.Unit != this.$attrs.tableData.Unit) {
              item.Qty = Number("").toFixed(
                tool.getLocal("get_config").moneyPoint
              );
            }
          });
          setTimeout(() => {
            this.$refs.xTable.updateData();
            this.$refs.xTable.updateFooter();
          }, 400);
        } else {
          setTimeout(() => {
            this.$refs.xTable.updateData();
            this.$refs.xTable.updateFooter();
          }, 400);
        }
      },
    },
  },

  methods: {
    open() {
      this.$refs.xTable.recalculate();
    },
    // 换算合计
    changeData(data, index, field, name, vctype) {
      let obj = [];
      let objg = "";
      for (let index = 0; index < this.tableDatasl.length; index++) {
        const element = this.tableDatasl[index];
        element.Qty = Number(element.Qty).toFixed(
          tool.getLocal("get_config").moneyPoint
        );
        obj.push({ Qty: Number(element.Percent) * Number(element.Qty) });
      }
      this.Total = this.sum(obj, "Qty"); // Number(item.sl);
    },
    sum(data, e) {
      let d = 0;
      data.map((item) => {
        if (item.Qty != "") {
          d += Number(item[e]);
        }
      });
      return Number(d).toFixed(tool.getLocal("get_config").moneyPoint);
    },
    // 聚焦
    doFocu(event, val, Key) {
      event.currentTarget.select();
    },
    // 确定按钮
    clickDetermine() {
      this.$emit("chooseBack", this.tableDatasl, this.Total);
      this.$emit("update:show", false);
    },
    distinctObj(numberArr, ind) {
      let obj = "";
      for (var i of numberArr) {
        if (i.id == ind) {
          obj = i;
          return obj;
        }
      }
      return false;
    },
    // 上键
    UpArrows(row, rowIndex, index) {
      if (this.vchtype == 1) {
        rowIndex = rowIndex - 1;
        if (
          this.distinctObj(
            this.$refs.Serialfocus,
            `x_${rowIndex}_y_${index}`
          ) !== false
        ) {
          this.distinctObj(
            this.$refs.Serialfocus,
            `x_${rowIndex}_y_${index}`
          ).focus();

          this.highlightcurren(rowIndex);
        }
      }
      if (this.vchtype == 2) {
        rowIndex = rowIndex - 1;
        if (
          this.distinctObj(
            this.$refs.Serialfocusxlh,
            `x_${rowIndex}_y_${index}`
          ) !== false
        ) {
          this.distinctObj(
            this.$refs.Serialfocusxlh,
            `x_${rowIndex}_y_${index}`
          ).focus();
          this.highlightcurren(rowIndex);
        }
      }
    },
    // 下键
    downArrows(row, rowIndex, index) {
      if (this.vchtype == 2) {
        rowIndex = rowIndex + 1;
        if (
          this.distinctObj(
            this.$refs.Serialfocusxlh,
            `x_${rowIndex}_y_${index}`
          ) !== false
        ) {
          this.distinctObj(
            this.$refs.Serialfocusxlh,
            `x_${rowIndex}_y_${index}`
          ).focus();
          this.highlightcurren(rowIndex);
        }
      }
    },
    // 回车键
    DwArrows(row, rowIndex, index) {
      if (this.vchtype == 1) {
        rowIndex = rowIndex + 1;
        if (
          this.distinctObj(
            this.$refs.Serialfocus,
            `x_${rowIndex}_y_${index}`
          ) !== false
        ) {
          this.distinctObj(
            this.$refs.Serialfocus,
            `x_${rowIndex}_y_${index}`
          ).focus();
          this.highlightcurrens(rowIndex);
        }
      }
      if (this.vchtype == 2) {
        for (let i = index + 1; i < this.ObtainHeaderxlh.length + 1; i++) {
          if (
            this.distinctObj(
              this.$refs.Serialfocusxlh,
              `x_${rowIndex}_y_${i}`
            ) !== false
          ) {
            this.distinctObj(
              this.$refs.Serialfocusxlh,
              `x_${rowIndex}_y_${i}`
            ).focus();
            return;
          } else if (i + 1 == this.ObtainHeaderxlh.length + 1) {
            rowIndex = rowIndex + 1;
            if (
              this.distinctObj(
                this.$refs.Serialfocusxlh,
                `x_${rowIndex}_y_1`
              ) != false
            ) {
              this.distinctObj(
                this.$refs.Serialfocusxlh,
                `x_${rowIndex}_y_1`
              ).focus();
              this.highlightcurren(rowIndex);
            }
          }
        }
      }
    },

    // 滚动条 上移
    highlightcurren(dire) {
      if (this.vchtype == 2) {
        this.$refs.xTable.setCurrentRow(this.tableDataxlh[dire]);
        this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
      }
      if (this.vchtype == 1) {
        this.$refs.xTable.setCurrentRow(this.tableDatasl[dire]);
        this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
      }
    },
    // 滚动条 下移
    highlightcurrens(dire) {
      if (this.vchtype == 2) {
        this.$refs.xTable.setCurrentRow(this.tableDataxlh[dire]);
        this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
      }
      if (this.vchtype == 1) {
        this.$refs.xTable.setCurrentRow(this.tableDatasl[dire]);
        this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
      }
    },
    // 退出清除数据
    clearData() {
      // 退出前是数据初始化
      this.$emit("update:show", false);
    },
  },
  // 创建生命周期钩子函数
  mounted() {},
};
</script>
<style lang="less">
.only_show_div {
  width: 100%;
  height: 100%;
  line-height: 30px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.sty_colls {
  width: 200px;
  box-sizing: border-box;
  margin-right: 37px;
  margin-top: 10px !important;
}
.sty_collsb {
  box-sizing: border-box;
  margin-right: 37px;
  margin-top: 10px !important;
}

.el-input--medium .el-input__inner {
  height: 30px;
  line-height: 30px;
  border-radius: 0;
}
.btnnimiserial {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}
.btnnimiserials {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.inputserial {
  display: flex;
  // justify-content: center;
  margin-left: 40px;
}
.MaInputg {
  .label_sty {
    color: #333;
    font-size: 12px;
    padding: 0 5px;
    height: 100%;
    line-height: 28px;
    font-weight: bold;
    display: inline-block;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 45px;
  }
}
.vxe-table.t--border.scroll--y .vxe-body--column:last-child,
.vxe-table.t--border.scroll--y .vxe-footer--column:last-child,
.vxe-table.t--border.scroll--y .vxe-header--column:last-child,
.vxe-table.t--border .vxe-body--column,
.vxe-table.t--border .vxe-footer--column,
.vxe-table.t--border .vxe-header--column {
  padding: 0 !important;
}
.vxe-table .vxe-cell {
  padding: 0 !important;
  overflow: hidden;
}
.input_stt {
  height: 30px;
  width: 100%;
  display: block;
  position: relative;
  -webkit-box-flex: 1;
  box-flex: 1;
  padding: 0 !important;
  background: #fff;
  display: block;
  box-sizing: border-box;
  padding: 0 0;
  border: 0; //可根据需要修改有无边框显示长度和宽带
  overflow: hidden;
  // outline: none;
  text-align: center;
}
.content_btn_box {
  display: -webkit-box !important;
  display: box !important;
  position: relative;
  -webkit-box-align: center;
  box-align: center;
}
#key_content:focus {
  outline: none;
  border: 0;
  border-color: red;
}
.el-dialog__header {
  background: rebeccapurple;
  padding: 10px 10px 0;
  .el-dialog__title {
    color: #fff;
    font-size: 14px;
  }
  .el-dialog__headerbtn {
    top: 10px;
    right: 10px;
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }
  }
}
.el-dialog__body {
  padding: 10px 20px;
}
.MultipleRiod_box {
  width: 100%;
  height: 50px;
  margin-bottom: 4px;
  /* background-color: aqua; */
  padding: 10px 0;
  // border: 1px solid #dcdfe6;
  border-radius: 5px;
  box-shadow: 0px 0px 7px #ccc;

  h3 {
    text-indent: 20px;
    margin-bottom: 8px;
  }
  .dw {
    margin-left: 20px;
    span {
      margin-left: 180px;
    }
  }
}
.MultipleRiod_boxs {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.el-tree {
  background: inherit;
}
//滚动条的宽度
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
//滚动条的滑块
::-webkit-scrollbar-thumb {
  //   background-color: #a1a3a9;
  //   border-radius: 3px;
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ccc;
}
:-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/MultipleRiod/MultipleRiod.vue